import "./style.scss";

import Vue from 'vue'
const routes = [];

const RouterView = { render (c) { return c('router-view') } };

//import PricingProduct from "./areas/pricing";
//Vue.component("pricingProduct", PricingProduct);

import Messages from "./messages";

routes.push({ path: "messages", component: RouterView, meta: { label: "Beskeder" }, children: [
    { path: "", component: Messages, name: "messages", meta: { module: "messages" } },
] });

export { routes };
